import { render } from "./CandidateDetails.vue?vue&type=template&id=d650e724"
import script from "./CandidateDetails.vue?vue&type=script&lang=js"
export * from "./CandidateDetails.vue?vue&type=script&lang=js"

import "./CandidateDetails.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__